
























import type { Brand } from "@constructor/shared-entity/type";
import { defineComponent, type PropType } from "vue-demi";

export default defineComponent({
  name: "GGBrandGrid",
  props: {
    list: {
      type: Array as PropType<Brand[]>,
      required: true,
    },
  },
});
